import pathRoutes from "routes/pathRoutes";
import ButtonView from "./Pages/ButtonView";
import ViewTable from "./Pages/ViewTable";

export const viewRoute = [
  {
    page: ButtonView,
    path: pathRoutes.view.button,
  },
  {
    page: ViewTable,
    path: pathRoutes.view.table,
  },
];
